<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Store Name</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.name" />
		</div>
		<div>Admin Email</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="email" max="500" [(ngModel)]="venueService.ooVenue.email" />
		</div>
		<div>Phone</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.phone" />
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div>Address 1</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.address1" />
		</div>
		<div>Address 2</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.address2" />
		</div>
		<div>City</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.city" />
		</div>
		<div>State</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.state" />
		</div>
		<div>Postal Code</div>
		<div class="mb-3">
			<input pInputText (change)="changesToSaveChange.emit(true)" class="w-100" type="text" [(ngModel)]="venueService.ooVenue.zip" />
		</div>
	</div>
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<img
			class="w-100 mb-3"
			[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueService.venueKey + '/logo.png?' + timestamp"
			onError="this.src='https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/no-image-found-360x250.png'"
		/>
		<div class="mb-3">
			<p-button pRipple styleClass="p-button-raised w-100" (click)="selectImage('logo')">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
					Edit Logo
				</ng-template>
			</p-button>
		</div>
		<div>Timezone</div>
		<div class="mb-3">
			<p-dropdown
				[options]="timezones"
				[autoDisplayFirst]="false"
				placeholder="Select Timezone"
				[style]="{ width: '100%' }"
				[(ngModel)]="venueService.ooVenue.timezone"
			>
			</p-dropdown>
		</div>
	</div>
</div>
